<div class="public-container">
  <div class="left-side-container">
    <!-- Logo -->
    <figure>
      <img src="assets/images/logo.svg" alt="SBI" />
    </figure>

    <!-- Forced Password Change Form -->
    <form
      [formGroup]="passwordForm"
      (ngSubmit)="onSubmit()"
      class="password-form"
      [class.form-loading]="changing$ | async"
    >
      <div class="title-section">
        <h2 class="public-form-title">Actualizar contraseña</h2>
        <p class="subtitle">
          Por seguridad, necesitás crear una nueva contraseña para continuar
          usando el portal.
        </p>
      </div>

      <!-- New Password Field -->
      <div class="field-wrapper">
        <custom-text-field
          [type]="'password'"
          formControlName="newPassword"
          label="Nueva contraseña"
          inputId="newPassword"
          [errors]="newPasswordErrors"
        ></custom-text-field>
      </div>

      <!-- Password Validation Indicators -->
      <app-password-validation-indicators
        [passwordControl]="passwordForm.get('newPassword')!"
      ></app-password-validation-indicators>

      <!-- Repeat New Password Field -->
      <div class="field-wrapper">
        <custom-text-field
          [type]="'password'"
          formControlName="newPasswordRepeat"
          label="Repetir nueva contraseña"
          inputId="newPasswordRepeat"
          [errors]="repeatPasswordErrors"
        ></custom-text-field>
        <!-- Password match success message -->
        <p
          class="password-match-success"
          *ngIf="
            passwordForm.get('newPasswordRepeat')!.value &&
            !passwordForm.get('newPasswordRepeat')!.hasError('passwordMismatch')
          "
        >
          Las contraseñas coinciden
        </p>
      </div>

      <!-- Submit Button -->
      <div class="button-container">
        <button
          type="submit"
          class="submit-button"
          [disabled]="passwordForm.invalid || (changing$ | async)"
        >
          <i
            class="pi submit-button__icon"
            [ngClass]="(changing$ | async) ? 'pi-spin pi-spinner' : 'pi-lock'"
          ></i>
          <span class="submit-button__text">Actualizar contraseña</span>
        </button>
      </div>

      <!-- Volver al inicio de sesión -->
      <div class="back-to-login">
        <a routerLink="/login">
          <i class="pi pi-chevron-left"></i>
          Volver al inicio de sesión
        </a>
      </div>
    </form>
  </div>
</div>
